import axiosInstance from './api_helper';
const BASE='/api/woocommerce/orders';
export const getWooCommerceOrders=(params)=>axiosInstance.get(BASE,{params});
export const getWooCommerceOrder=(id)=>axiosInstance.get(`${BASE}/${id}`);
export const getWooCommerceOrderDeliveryNoteNumber=(id)=>axiosInstance.get(`${BASE}/${id}/delivery-note-number`);
export const updateWooCommerceOrderStatus=(id,status)=>axiosInstance.put(`${BASE}/${id}/status`,null,{params:{status}});
export const associateWooCommerceOrderItem=(orderId,itemId,articleId)=>axiosInstance.put(`${BASE}/${orderId}/items/${itemId}/article/${articleId}`);
export const convertWooCommerceOrderToDeliveryNote=(id,payload)=>axiosInstance.post(`${BASE}/${id}/delivery-note`,payload);
